class LoanSummaryController {
  /*@ngInject*/
  constructor() {
    this.name = 'loanSummary'
  }
}

export default LoanSummaryController
